import { Observable, ObserverEvents } from '..';

class AuthObservable extends Observable {
	invalidToken() {
		this.notify(ObserverEvents.INVALID_TOKEN);
	}
	companyWatcherInvalidToken() {
		this.notify(ObserverEvents.COMPANY_WATCHER_INVALID_TOKEN);
	}
}

const authObservable = new AuthObservable();

export { authObservable };
